<template>
  <vi-page>
    <AccountAdd
      :url="url"
      :addurl="addurl"
      :addType="addType"
      :text="text"
      :type="type"
    ></AccountAdd>
  </vi-page>
</template>

<script>
import AccountAdd from "../../../../../../controls/customer/AccountAdd";
export default {
  name: "PagesDashboardCustomerDetailAccount",
  components: {
    AccountAdd,
  },
  data() {
    return {
      url: "/shiyun/aliyun/apis/data/customer",
      addurl: "/shiyun/aliyun/apis/biz/customer/account/add",
      addType: "客户",
      text: "该用户尚未开通账号，请开通账号",
      type: "customerSN",
    };
  },
};
</script>

<style>
</style>